import { NotificationListItemFragment } from "gql/graphql";
import Text from "@/shared/typography/text";
import { usePalette } from "@/shared/theme";
import { CSSProperties, useRef } from "react";
import { useAgoFormatter } from "@/shared/formatters";
import { Title } from "@/modules/common/widgets/notification-bell/ui/title";
import { LinkForTitle } from "@/modules/common/widgets/notification-bell/ui/link-for-title";
import { useInView } from "react-hook-inview";

export function NotificationListItem({
  notification,
  read,
}: {
  notification: NotificationListItemFragment;
  read: (id: string) => void;
}) {
  const ago = useAgoFormatter(notification.createdDate);
  const palette = usePalette();
  const titleText = <Title>{notification.title.value}</Title>;

  const timer = useRef<ReturnType<typeof setTimeout> | null>();

  const [ref] = useInView({
    onEnter: () => {
      if (notification.wasRead) {
        return;
      }

      timer.current = setTimeout(() => {
        read(notification.id);
        timer.current = null;
      }, 3000);
    },
    onLeave: () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    },
  });

  return (
    <div ref={ref} onClick={() => read(notification.id)}>
      <div>
        {notification.url ? (
          <LinkForTitle to={notification.url}>{titleText}</LinkForTitle>
        ) : (
          <>{titleText}</>
        )}
      </div>

      {notification.description.value && (
        <div className={"mt-3"}>
          <Text
            type={"body3"}
            className={"!text-[--color]"}
            style={{ "--color": palette.neutral[7] } as CSSProperties}
          >
            <span
              className={"break-words"}
              dangerouslySetInnerHTML={{
                __html: notification.description.value,
              }}
            />
          </Text>
        </div>
      )}

      <div className={"mt-3"}>
        <Text
          type={"body3"}
          className={"!text-[--color]"}
          style={{ "--color": palette.neutral[6] } as CSSProperties}
        >
          {ago}
        </Text>
      </div>
    </div>
  );
}
